import { Model } from 'pinia-orm';

export default class Media extends Model {
  static entity = 'media';

  static fields() {
    return {
      id: this.uid(),
      mediaType: this.attr(''),
      /*      posts: this.morphedByMany(
        Post, Mediable, 'media_id', 'mediable_id', 'mediable_type'),*/
      url: this.attr(''),
      urls: this.attr(''),
    };
  }
}
